import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AccordionFullTable, CreateChancel } from 'components';
import { useModal, sortListByKey, onModelFolderEnum, FindLoadItem, FindSuccessItem } from 'utils';
import { httpRequestsOnSuccessActions, libraryActions } from 'store';
import { OptionsChooseDetailsFromLibrary } from './optionsChooseDetailsFromLibrary';
import { optionsChooseFromLibraryTableInfo } from './constants';

export const OptionsChooseFromLibrary = ({ CHOOSE_ACTION_TYPE, action, goalById, fromTheLibrary }) => {
    const [selectedMap, setSelectedMap] = useState(new Map());
    const { libraryFolders } = useSelector((state) => ({
        libraryFolders: state.library.libraryFolders,
    }));
    const dispatch = useDispatch();
    // const navigate = useNavigate();
    // const info = location?.state;
    const { close } = useModal();
    const loading = FindLoadItem(CHOOSE_ACTION_TYPE);
    const success = FindSuccessItem(CHOOSE_ACTION_TYPE);
    const [sendParams, setSendParams] = useState({
        skip: 0,
        limit: 50,
    });

    const renderParams = () => {
        const pushInfo = {
            ...sendParams,
            goalId: goalById?.id,
            onModel: onModelFolderEnum.OPTION,
            fromTheLibrary,
        };
        pushInfo.skip = sendParams?.skip ? sendParams?.skip : 0;
        pushInfo.limit = 50;

        delete pushInfo.page;
        delete pushInfo.activeTab;
        delete pushInfo.tabType;
        return pushInfo;
    };

    useEffect(() => {
        if (success?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(success));
            close();
        }
    }, [success]);

    useEffect(() => {
        getFolders();
    }, [sendParams]);

    const copiedItems = Array.from(selectedMap, ([folderId, optionsIds]) => ({
        folderId,
        optionsIds: Array.from(optionsIds),
    }));

    const getFolders = (load) => {
        dispatch(libraryActions.getLibraryFolders(renderParams(), load));
    };

    const toggleItem = ({ folderId, optionId = null, checked }) => {
        setSelectedMap((prev) => {
            const newMap = new Map(prev);

            if (optionId) {
                const oldSet = newMap.get(folderId) || new Set();
                const newSet = new Set(oldSet);

                if (checked) newSet.add(optionId);
                else newSet.delete(optionId);

                if (newSet.size > 0) newMap.set(folderId, newSet);
                else newMap.delete(folderId);
            } else {
                const folder = libraryFolders?.data?.find((f) => f.id === folderId);
                if (!folder) return prev;

                if (checked) {
                    newMap.set(folderId, new Set(folder.options.map((t) => t.id)));
                } else {
                    newMap.delete(folderId);
                }
            }

            return new Map(newMap);
        });
    };

    const handleChoose = () => {
        if (copiedItems?.length) {
            dispatch(action(goalById?.id, { copiedItems }));
        }
    };

    return (
        <div style={{ width: '1280px', maxWidth: '100%' }}>
            <h3 className="modal-header-title">Choose from Library</h3>
            <div className="library-targets-tab-wrapper">
                <AccordionFullTable
                    getParams={setSendParams}
                    savedParams={sendParams}
                    classNameWrapper="library-targets-tab-accordion-wrapper"
                    renderAccordionDetails={(item) => (
                        <OptionsChooseDetailsFromLibrary currentFolder={item} selectedMap={selectedMap} toggleItem={toggleItem} />
                    )}
                    tableInfo={optionsChooseFromLibraryTableInfo({
                        toggleItem,
                        selectedMap,
                        libraryFolders: libraryFolders?.data,
                    })}
                    list={sortListByKey(libraryFolders?.data, 'name', sendParams)}
                    listCount={libraryFolders?.count}
                    margin={'24px 0 24px'}
                    containerStyles={{
                        height: '60vh',
                        position: 'relative',
                    }}
                />
            </div>

            <CreateChancel
                disabled={!copiedItems?.length}
                type="button"
                loader={loading?.loadingType}
                onCreate={handleChoose}
                create={'Add'}
                chancel={'Cancel'}
                onClose={close}
                buttonWidth="218px"
                justifyContent={'flex-end'}
                cancelRight={'24px'}
            />
        </div>
    );
};
